import { observer } from "mobx-react-lite";
import React from "react";
import { TicketMetaField } from "../../../types/field_configs/Meta";
import { NumberOptions } from "./options/NumberOptions";
import { ParseSelectOptions } from "./options/ParseSelectOptions";
import { SelectOptions } from "./options/SelectOptions";

type Props = {
  field: TicketMetaField;
};

type MetaFieldOptionsMapType = {
  [key in TicketMetaField["type"]]?: React.FC<{
    field: TicketMetaField;
  }> | null;
};

const MetaFieldTypeOptionsMap: MetaFieldOptionsMapType = {
  boolean: null,
  string: null,
  number: NumberOptions,
  date: null,
  select: SelectOptions,
  select_parse: ParseSelectOptions,
};

export const MetaFieldTypeOptions = observer((props: Props) => {
  const Component = MetaFieldTypeOptionsMap[props.field?.type];

  return (
    <div style={{ width: "100%" }}>
      {Component && <Component field={props.field} />}
    </div>
  );
});
